import {get, includes} from 'lodash';

import {ProbeProcessor} from '../types';

export function isDisabledProperty(propertyName: string, processor: ProbeProcessor) {
  if (processor.type === 'bgp_session') {
    return includes(['service_input', 'execution_count', 'service_interval'], propertyName) &&
      !get(processor, ['properties', 'enable_telemetry_service']);
  }
  return false;
}
